import { StarIcon } from "@phosphor-icons/react";
import { useTranslations } from "use-intl";

import { Image } from "@/components/Image/Image";
import { HotelRoom } from "@/features/hotels/components/hotel/HotelRoom";
import { boardIcons } from "@/features/hotels/components/hotels/BoardIcons";
import { HotelName } from "@/features/hotels/components/hotels/HotelName";
import type { HotelBooking, HotelData } from "@/features/hotels/types/types";

type Props = {
  hotel: HotelData;
  hotelBookingData: HotelBooking;
  rooms?: { adults: number; children: number }[];
};

export const HotelAndRoomCard = ({ hotel, hotelBookingData, rooms }: Props) => {
  const t = useTranslations();

  return (
    <div className="section-card flex flex-col gap-4">
      <div className="flex gap-4">
        <div>
          {hotel.mainImageUrl && (
            <div className="flex-end flex w-full">
              <Image
                className="min-h-32 min-w-24 rounded-2xl object-cover"
                width="90"
                height="130"
                src={hotel.mainImageUrl}
                alt={hotel.name}
              />
            </div>
          )}
        </div>
        <div>
          <span className="mb-1 font-bold text-text-title">
            <HotelName name={hotel.name} />
          </span>
          <div className="flex flex-col gap-2">
            {!!hotel.stars && (
              <div className="flex items-center gap-2">
                <div className="flex">
                  {Array.from(Array(Number(hotel.stars))).map((_, index) => (
                    <StarIcon
                      key={index}
                      size={12}
                      color="var(--color-semantic-error-pressed-medium)"
                      weight="fill"
                    />
                  ))}
                </div>
                <span className="text-sm text-text-secondary">
                  {t("hotels.card.stars", { stars: hotel.stars })}
                </span>
              </div>
            )}
            {hotel?.boardBasis?.map((bb) => (
              <div key={bb} className="flex items-center">
                <div className="flex items-center gap-2 text-xs text-text-primary">
                  {boardIcons[bb]}
                  {t(`hotels.boardBasis.${bb}`)}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {rooms &&
        hotelBookingData.rooms.map((room, index) => (
          <div key={room.roomToken} className="flex w-full flex-col gap-2">
            <HotelRoom
              room={room}
              adultCount={rooms[index].adults}
              childrenCount={rooms[index].children}
            />
            {/* Travellers assignment dropdown is hidden because we don't support booking multiple rooms yet */}
            {/* <div className="mt-2">
                  <HotelRoomTravelers
                    onTravelersSelect={(travelers) => {
                      form.setFieldValue("roomAssignments", {
                        ...form.values.roomAssignments,
                        [room.roomToken]: {
                          travelers,
                        },
                      });
                    }}
                    selectedTravelers={
                      form.values.roomAssignments[room.roomToken]?.travelers ?? []
                    }
                    travelers={selectedTravellers.map((traveler) => {
                      return {
                        ...traveler,
                        // check if the traveler is already assigned to a room
                        available: !Object.values(form.values.roomAssignments)
                          .flatMap((assigment) => assigment.travelers)
                          .includes(traveler.id),
                      };
                    })}
                  />
                </div> */}
          </div>
        ))}
    </div>
  );
};
